import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import React, { useContext } from 'react';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';

interface Props {
  farenetTravelClass: string;
  travelClass?: string;
  showFareBrand?: boolean;
  showFareBrandData?: boolean;
  fareBrand?: StyledProps;
  fareBrandSettings?: StyledProps;
}

export type FareItemTravelClassProps = StyledProps<Props>;

type fareBrandOptions = {
  [key: string]: string;
};

const fareBrandMap: fareBrandOptions = {
  lt: 'lite',
  ch: 'choice',
  fl: 'flex',
  bu: 'business'
};

function FareItemTravelClass(props: FareItemTravelClassProps) {
  const {
    farenetTravelClass = '',
    showFareBrand = false,
    showFareBrandData = false,
    fareBrand = {},
    fareBrandSettings = {},
    travelClass = ''
  } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  let newTravelClass = travelClass;

  if (showFareBrandData) {
    if (travelClass !== '') {
      const value = fareBrandMap[travelClass.toLocaleLowerCase()];
      newTravelClass = value !== undefined ? value : travelClass.toLocaleLowerCase();
    }
  }

  return (
    <Box className={`fare-item-travel-class ${className}`} style={style}>
      {showFareBrandData && travelClass !== '' && (
        <Text marginRight="1" floatLeft {...fareBrandSettings}>
          {`${translate(
            `cmp-travel-class-fare-brand-${newTravelClass}`,
            newTravelClass.charAt(0).toUpperCase() + newTravelClass.substring(1)
          )}`}
        </Text>
      )}
      <Text floatLeft>
        {translate(
          `cmp-travel-class--${farenetTravelClass.toLowerCase().replace('_', '-')}`,
          `cmp-travel-class--${farenetTravelClass.toLowerCase().replace('_', '-')}`
        )}
      </Text>
      {showFareBrand && (
        <Text textTransform="uppercase" marginLeft="1" floatLeft {...fareBrand}>
          {`(${translate(
            `cmp-travel-class--${farenetTravelClass.toUpperCase().replace('_', '-')}`,
            `cmp-travel-class--${farenetTravelClass.toUpperCase().replace('_', '-')}`
          )})`}
        </Text>
      )}
    </Box>
  );
}

FareItemTravelClass.componentName = 'FareItemTravelClass';

export default FareItemTravelClass;
